/* eslint-disable sort-keys */
export default {
  light: {
    "error-placement-background": "neutral-800",
    "error-placement-text-disabled": "neutral-500",
    "system-message-alert-background": "neutral-900",
    "system-message-alert-icon": "primary-500",
    "system-message-background": "primary-950",
    "system-message-border": "primary-900",
    "system-message-list-item-divider": "neutral-500",
    "text-block-text-light": "neutral-900",
  },
  dark: {
    "error-placement-background": "primary-350",
    "error-placement-text-disabled": "primary-900",
    "system-message-alert-background": "primary-350",
    "system-message-alert-icon": "primary-900",
    "system-message-background": "primary-350",
    "system-message-border": "primary-200",
    "system-message-list-item-divider": "primary-200",
    "text-block-text-light": "primary-900",
  },
};
